import React, {useEffect, useState} from "react";
import CardStats from "components/Cards/CardStats";
import { API_BASE_URL } from "config/constants";
import axios from "axios";
import { handleError } from "utils";
import { getAccessToken } from "utils";

// components

export default function Dashboard() {
  const [data, setData] = useState({
    totalAdRequests: 0,
    totalMatchRequests: 0,
    impressions: 0,
    revenue: 0,
    cpm: 0,
  });
  const [gettingData, setGettingData] = useState(false);

  const get = async () => {
    try {
      setGettingData(true);

      const responce = await axios.get(
        `${API_BASE_URL}/analytic/dashboardAnalytics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: getAccessToken(),
          },
        }
      );

      setGettingData(false);
      const apiData = responce.data;
      setData(apiData?.result?.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };


  useEffect(() => {
    get();
  }, []);

  return (
    <>
      <div className="relative pb-32">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-6/12 px-4 mb-8">
                <CardStats
                  statSubtitle="Total Ad Requests"
                  statTitle={data.totalAdRequests}
                  statArrow="up"
                  statPercent="3.48"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-6/12 px-4 mb-8">
                <CardStats
                  statSubtitle="Total Match Requests"
                  statTitle={data.totalMatchRequests}
                  statArrow="down"
                  statPercent="3.48"
                  statPercentColor="text-red-500"
                  statDescripiron="Since last week"
                  statIconName="fas fa-chart-pie"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-6/12 px-4 mb-8">
                <CardStats
                  statSubtitle="Impressions"
                  statTitle={data.impressions}
                  statArrow="down"
                  statPercent="1.10"
                  statPercentColor="text-orange-500"
                  statDescripiron="Since yesterday"
                  statIconName="fas fa-users"
                  statIconColor="bg-pink-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-6/12 px-4 mb-8">
                <CardStats
                  statSubtitle="Revenue"
                  statTitle={"$" + data.revenue.toFixed(2)}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-percent"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-6/12 px-4 mb-8">
                <CardStats
                  statSubtitle="Total CPM"
                  statTitle={"$" + data.cpm.toFixed(2)}
                  statArrow="up"
                  statPercent="12"
                  statPercentColor="text-emerald-500"
                  statDescripiron="Since last month"
                  statIconName="fas fa-chart-pie"
                  statIconColor="bg-emerald-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
